import he from 'he';
import jwtDecode from 'jwt-decode';
import fp from 'lodash/fp';
import queryString from 'query-string';
import React from 'react';
import { Navbar, ProgressBar } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { compose, withProps } from 'recompose';
import { routes } from '../../../constants';
import logo from '../../../images/logo_rev.svg';
import { stripeConfigSelector } from '../../../state/modules/configuration/selectors';

const TOTAL_SIGNUP_STEPS = 2;
const TOTAL_INDIVIDUAL_STEPS = 3;
const TOTAL_TEAM_STEPS = 4;

const OnboardingNav = ({
  description,
  progressLabel,
  progressPercentage,
  step
}) => (
    <Navbar className='navbar-signup container-flex' role='navigation' fluid={true}>
      <Navbar.Header className='flex-header'>
        <Navbar.Toggle />
        <Navbar.Brand>
          <Link to={routes.app.dashboard}>
            <img src={logo} alt='Caddie' />
          </Link>
        </Navbar.Brand>
      </Navbar.Header>
      {
        step ?
          <ProgressBar now={progressPercentage} label={progressLabel} className='flex-header' /> :
          null
      }
      <Navbar.Collapse className='flex-header'>
        <Navbar.Text pullRight>{description}</Navbar.Text>
      </Navbar.Collapse>
    </Navbar>
  );

const mapStateToProps = (state) => ({
  config: stripeConfigSelector(state),
  isUserAcceptedInvitation: state.global.onboarding.isUserAcceptedInvitation
});

export default compose(
  withRouter,
  connect(mapStateToProps),
  withProps(({
    config,
    location: {
      search
    },
    selectedPlan
  }) => ({
    isInviationSignUp: queryString.parse(search).invitationToken,
    isTeamPlan: selectedPlan && config && selectedPlan.id !== config.plansInUse.Individual,
    onboardingNavText: selectedPlan ?
      `${he.decode(selectedPlan.name)} sign up` :
      'Sign up'
  })),
  withProps(({
    isInviationSignUp,
    isTeamPlan,
    location: {
      search
    },
    onboardingNavText
  }) => ({
    description: fp.flow(
      (query) => fp.attempt(
        () => fp.flow(
          queryString.parse,
          fp.get('invitationToken'),
          (invitationToken) => invitationToken ?
            fp.flow(
              jwtDecode,
              fp.get('businessName')
            )(invitationToken) :
            onboardingNavText
        )(query)
      ),
      (description) => fp.isError(description) ?
        onboardingNavText :
        description
    )(search),
    totalOnboardingSteps: isTeamPlan && !isInviationSignUp ?
      TOTAL_TEAM_STEPS :
      TOTAL_INDIVIDUAL_STEPS
  })),
  withProps(({
    totalOnboardingSteps
  }) => ({
    steps: {
      [routes.onboarding.signup]: {
        current: 1,
        total: TOTAL_SIGNUP_STEPS
      },
      [routes.onboarding.billing]: {
        current: 2,
        total: TOTAL_SIGNUP_STEPS
      },
      [routes.onboarding.afsLicence]: {
        current: 1,
        total: totalOnboardingSteps
      },
      [routes.onboarding.cpdCategorys]: {
        current: 2,
        total: totalOnboardingSteps
      },
      [routes.onboarding.cpdRequirements]: {
        current: 3,
        total: totalOnboardingSteps
      },
      [routes.onboarding.teamInvite]: {
        current: 4,
        total: totalOnboardingSteps
      },
      [routes.onboarding.invitationSignUp]: {
        current: 1,
        total: totalOnboardingSteps
      }
    }
  })),
  withProps(({
    location: {
      pathname
    },
    steps
  }) => ({
    step: fp.get(pathname)(steps)
  })),
  withProps(({
    step
  }) => ({
    progressLabel: step ?
      <span className='progress-level'>
        {`Step ${step.current} of ${step.total}`}
      </span> :
      null,
    progressPercentage: step ?
      (step.current / step.total) * 100 :
      null
  }))
)(OnboardingNav);



// WEBPACK FOOTER //
// ./src/containers/partials/nav/onboarding-nav.js